import { DwarvesPage} from '../DwarvesPage/DwarvesPage'

export const BearPeaks = () => {
    return <div>
        <DwarvesPage/>
    </div>
}


